import React, { useState } from "react"
import { Grid, makeStyles, createStyles, Theme, Card, CardMedia, Typography, CardContent, CardActionArea } from "@material-ui/core"
import BackgroundImage from '../../resources/images/background.jpg'
import RgbCardImage from './resources/images/rgb-selector.png'
import IntelliCardImage from './resources/images/intelli-nail.jpg'
import { Link } from "react-router-dom"

const useStyles = makeStyles((theme: Theme) => createStyles({
    container: {
        minHeight: "100vh",
        backgroundImage: `url(${BackgroundImage})`,
        backgroundSize: "cover",
    },
    media: {
        height: "35em",
    },
}));

const Login: React.FC = () => {
    const classes = useStyles();

    const [rgbHover, setRgbHover] = useState<boolean>(false);
    const [intelliHover, setIntelliHover] = useState<boolean>(false);

    return (
        <div className={classes.container}>
            <Grid className={classes.container} container direction="row" justify="space-evenly" alignItems="center">
                <Grid item xs={5}>
                    <Card style={{ boxShadow: rgbHover ? "5px 5px 5px #666" : "" }} onMouseEnter={() => setRgbHover(true)} onMouseLeave={() => setRgbHover(false)}>
                        <CardActionArea component={Link} to="/mixer">
                            <CardMedia className={classes.media} image={RgbCardImage} />
                            <CardContent>
                                <Typography variant="h2">RGB Mixer</Typography>
                                <Typography variant="body1">Infinite possibilities, nail polish for you, by you.</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
                <Grid item xs={5}>
                    <Card style={{ boxShadow: intelliHover ? "5px 5px 5px #666" : "" }} onMouseEnter={() => setIntelliHover(true)} onMouseLeave={() => setIntelliHover(false)}>
                        <CardActionArea component={Link} to="/mixer">
                            <CardMedia className={classes.media} image={IntelliCardImage} />
                            <CardContent>
                                <Typography variant="h2">Intelli-nail Mixer</Typography>
                                <Typography variant="body1">Smart color detection algorithms pick the best colors based off outfit and apparel.</Typography>
                            </CardContent>
                        </CardActionArea>
                    </Card>
                </Grid>
            </Grid>
        </div>
    )
}

export default Login;
